import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';

export const shiftRoutes: Routes = [
    {
        path: 'dashboard/displacement-tool',
        title: 'Pulse Shift',
        canActivate: [productGuard('shift')],
        loadComponent: () =>
            import('app/products/displacement/dashboards/displacement-tool/displacement-tool.component').then(
                m => m.DisplacementToolComponent
            ),
    },
    {
        path: 'dashboard/displacement-config',
        title: 'Pulse Shift Config',
        canActivate: [productGuard('shift')],
        loadComponent: () =>
            import('app/products/displacement/dashboards/displacement-config/displacement-config.component').then(
                m => m.DisplacementConfigComponent
            ),
    },
];
